import {combineReducers} from 'redux';
import navigatorReducer from './navigator';

let reducer = combineReducers({
    navigatorReducer:navigatorReducer
});

export {
    reducer as default
};